module.exports = __webpack_public_path__ + "80ad17249df4922e434cff4900add17d.svg";